/**
 * Registriert Elemente bei {@link v3sWbtPlayerApp:page.controller_v3sPageCtrl v3sPageCtrl}
 * @class directive_v3sDocument
 * @memberOf v3sWbtPlayerApp:page
 */
angular.module('v3sWbtPlayerApp').directive('v3sDocument', ['$window', '$document', 'v3sLogoConfig', 'v3sContentMediaPath', 'v3sBrowserInfoService', function ($window, $document, v3sLogoConfig, v3sContentMediaPath, v3sBrowserInfoService) {
    return {
        restrict: 'E',
        controller: ["$scope", "$element", function ($scope, $element) {
            this.addElement = !!$scope.addElement ? $scope.addElement : function () { };
            this.getVar = !!$scope.getVar ? $scope.getVar : function () { };
        }],
        link: function (scope, element) {
            try{
                $window.top.scrollTo(0, 0);
            } catch (e) { }
            $window.scrollTo(0, 0);

            //set page background and css-id
            if (!!scope.currentPage) {
                var pageBackground = scope.currentPage.getPageBackground();
                var pageView = element.parent();
                var url = !!pageBackground.image ? "url('" + v3sContentMediaPath + pageBackground.image + "')" : "";
                var urlResponsive = !!pageBackground.responsiveImage ? "url('" + v3sContentMediaPath + pageBackground.responsiveImage + "')" : "";

                var isResponsive = v3sBrowserInfoService.isResponsiveView();

                var bgColor = isResponsive && !!pageBackground.responsiveColor ? pageBackground.responsiveColor : pageBackground.color;
                var bgImage = isResponsive && !!pageBackground.responsiveImage ? urlResponsive : url;

                var html = angular.element($document[0].documentElement);

                if (isResponsive) {
                    if (!!pageBackground.responsiveColor) {
                        element.parent().css("background-color", "transparent");
                    }
                    if (!!pageBackground.responsiveImage) {
                        html.css("background-color", bgColor);
                        element.parent().css("background-color", "transparent");
                        html.css("background-image", bgImage);
                    } else {
                        html.css("background-color", bgColor);
                        html.css("background-image", "");
                    }
                } else {
                    element.parent().css("background-color", bgColor);
                    element.parent().css("background-image", bgImage);
                    var playerBackground = scope.currentPage.getPlayerBackground();
                    html.css("background-color", playerBackground.color);

                    url = !!playerBackground.image ? "url('" + v3sContentMediaPath + playerBackground.image + "')" : "";
                    html.css("background-image", url);
                }

                element.attr("id", scope.currentPage.getId());
                
            }

            scope.$watch('hideContent', function () {
                if (!!scope.userData) {
                    element.addClass("hideContent");
                } else {
                    element.removeClass("hideContent");
                }
            });

            if (v3sLogoConfig.contentLogoPosition && v3sLogoConfig.contentLogoUrl && v3sLogoConfig.contentLogoUrl != "none") {
                var alignment = "center-block";

                if (v3sLogoConfig.contentLogoPosition.indexOf("left") > -1) {
                    alignment = "pull-left";

                } else if(v3sLogoConfig.contentLogoPosition.indexOf("right") > -1) {
                    alignment = "pull-right";
                }

                var logo = angular.element("<div class=\"contentLogo\"><img src=\"" + v3sContentMediaPath + v3sLogoConfig.contentLogoUrl + "\" class=\"" + alignment + "\"/></div>");

                if (v3sLogoConfig.contentLogoPosition.indexOf("bottom") > -1) {
                    element.append(logo);

                } else {
                    element.prepend(logo);
                }
            }
        }
    }
}]);